module.exports = __webpack_public_path__ + "img/zuzhi.e579c593.png";